/** Минимальный контракт статуса ККТ для preflight маркировки. */
export interface MarkingReadinessStatus {
  connected?: boolean
  ffdVersion?: string
  esmEnabled?: boolean
  markingSupport?: boolean
}

export interface MarkingReadiness {
  ok: boolean
  reason?: string
}

/**
 * Проверка готовности ККТ к маркировке ФФД 1.2.
 *
 * Fail-closed: если хотя бы один признак не подтверждён, маркированный чек
 * нельзя отправлять в ККТ. Это защищает от ложного «зелёного» preflight.
 */
export function checkMarkingReadiness(
  status: MarkingReadinessStatus | null | undefined
): MarkingReadiness {
  if (!status?.connected) return { ok: false, reason: 'ККТ не подключена' }

  const version = status.ffdVersion ?? ''
  const [majorRaw, minorRaw] = version.split('.')
  const major = Number(majorRaw)
  const minor = Number(minorRaw)
  if (!Number.isFinite(major) || !Number.isFinite(minor)) {
    return { ok: false, reason: 'Версия ФФД ККТ не определена' }
  }
  if (major < 1 || (major === 1 && minor < 2)) {
    return {
      ok: false,
      reason: `Нужен ФФД 1.2, ККТ сообщает ${version || 'неизвестно'}`
    }
  }
  if (status.esmEnabled !== true) {
    return { ok: false, reason: 'Не подтверждена лицензия ЕСМ/ЛМ Честного Знака' }
  }
  if (status.markingSupport !== true) {
    return { ok: false, reason: 'ККТ не поддерживает тег 2000 / imcParams' }
  }
  return { ok: true }
}
